import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components";
import DetailBtn from "../../../component/atoms/button/detailBtn";
import SearchBar from "../../../component/atoms/input/searchBar";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Table from "../../../component/atoms/layout/table/table";
import TableLayout from "../../../component/atoms/layout/table/tableLayout";
import TableSearchBtn from "../../../component/atoms/layout/table/tableSearchBtn";
import TableTop from "../../../component/atoms/layout/table/tableTop";
import Td from "../../../component/atoms/layout/table/td";
import Th from "../../../component/atoms/layout/table/th";
import Tr from "../../../component/atoms/layout/table/tr";
import PretendardText from "../../../component/atoms/text/pretendardText";
import TableText from "../../../component/atoms/text/table/tableText";
import TableTitle from "../../../component/atoms/text/table/tableTitle";
import Pagination from "../../../component/molecules/pagination";
import TableCount from "../../../component/molecules/tableCount";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import { route } from "../../../router/route";
import { isNull } from "../../../util/check";
import { errorHandler } from "../../../util/errorHandler";
import { saveAs } from "file-saver";
import ExcelApi from "../../../api/excel.api";
import { toast } from "react-toastify";
import ExcelBtn from "../../../component/atoms/button/excelBtn";
import Checkbox from "../../../component/atoms/input/checkbox";
import PayApi from "../../../api/pay.api";

const Pay = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    setKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");
    getPayList();
  }, [location]);

  const [payList, setPayList] = useState([1]);
  const [keyword, setKeyword] = useState("");

  const getPayList = async () => {
    try {
      const data = {
        keyword: searchParams.get("keyword"),
        page: searchParams.get("page"),
        size: pagination.size,
        paymentStatus: "COMPLETE",
      };
      let responseData = (await PayApi.getList(data)).data.data;
      setPayList(
        responseData.content.map((item) => {
          return {
            ...item,
            checked: false,
          };
        })
      );
      setPagination({
        ...pagination,
        totalCount: responseData.totalCount ? responseData.totalCount : 0,
        totalPages: Math.ceil(responseData.totalCount / pagination.size),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  // ----- 목록 가져오기
  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
  });

  const isAllCheck = useMemo(() => {
    const checkedList = payList.filter((item) => item.checked);
    return checkedList.length !== 0 && checkedList.length === payList.length;
  }, [payList]);

  //------------엑셀 생성
  const downloadExcel = async (excelData) => {
    const Excel = require("exceljs");
    const workbook = new Excel.Workbook();
    workbook.addWorksheet("Sheet One");
    const sheetOne = workbook.getWorksheet("Sheet One");

    sheetOne.columns = [
      { header: "강의명", key: "lectureTitle", width: 40 },
      { header: "아이디", key: "account", width: 40 },
      { header: "이름", key: "name", width: 40 },
      { header: "결제수단", key: "payMethod", width: 40 },
      { header: "결제금액", key: "realPay", width: 40 },
      { header: "결제일자", key: "createdAt", width: 40 },
    ];

    excelData.map((item) => {
      // 행 추가
      sheetOne.addRow(item);
    });
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), "결제 내역 관리.xlsx");
  };

  const getExcelAll = async () => {
    try {
      const excelArr = [];
      const response = (
        await ExcelApi.GetPaymentExcel({
          ids: [],
          allFlag: true,
          paymentStatus: "COMPLETE",
          keyword: searchParams.get("keyword"),
        })
      ).data.data.content;

      response.map((item) => {
        const realPay = item.realPay?.toLocaleString();
        const createDate = moment(item.createdAt).format("YYYY/MM/DD");
        excelArr.unshift({
          ...item,
          realPay: realPay,
          createdAt: createDate,
        });
      });

      downloadExcel(excelArr);
    } catch (error) {
      errorHandler(error);
    }
  };

  const getExcelChecked = async () => {
    const filter = payList.filter((item) => item.checked);
    if (filter.length <= 0) {
      return toast("항목을 선택해주세요");
    }

    try {
      const excelArr = [];
      const response = (
        await ExcelApi.GetPaymentExcel({
          ids: filter.map((item) => item.id),
          allFlag: false,
          paymentStatus: "COMPLETE",
          keyword: searchParams.get("keyword"),
        })
      ).data.data.content;

      response.map((item) => {
        const realPay = item.realPay?.toLocaleString();
        const createDate = moment(item.createdAt).format("YYYY/MM/DD");
        excelArr.unshift({
          ...item,
          realPay: realPay,
          createdAt: createDate,
        });
      });

      downloadExcel(excelArr);
    } catch (error) {
      errorHandler(error);
    }
  };
  //------------액셀 부분 끝

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <TableLayout>
          <TableTitle>결제 내역 관리</TableTitle>
          <TableTop>
            <TableCount text={"항목"} count={pagination.totalCount} />
            <TableSearchBtn>
              <SearchBar
                placeholder={"검색어를 입력하세요"}
                value={keyword}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    navigate(`${route.payment_pay}?page=1&keyword=${encodeURIComponent(keyword)}`, {
                      replace: true,
                    });
                  }
                }}
                onClick={() => {
                  navigate(`${route.payment_pay}?page=1&keyword=${encodeURIComponent(keyword)}`, {
                    replace: true,
                  });
                }}
              />
              <ExcelBtn
                onSelectClick={getExcelChecked}
                onAllClick={getExcelAll}
              />
            </TableSearchBtn>
          </TableTop>
          <Table>
            <colgroup>
              {/* 체크박스 영역 */}
              <col width="90px" />
              {/* 강의명 */}
              <col width={"250px"} />
              {/* 아이디 */}
              <col width={"142px"} />
              {/* 이름 */}
              <col width={"139px"} />
              {/* 결제수단 */}
              <col width={"109px"} />
              {/* 결제금액 */}
              <col width={"96px"} />
              {/* 결제일자 */}
              <col width={"140px"} />
              {/* 상세보기 */}
              <col width={"73px"} />
            </colgroup>
            <thead>
              <Tr style={{ height: "40px", background: "#f2f4f5" }}>
                <Th style={{ paddingLeft: "20px" }}>
                  <Checkbox
                    checked={isAllCheck}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setPayList(
                          payList.map((item) => {
                            return {
                              ...item,
                              checked: true,
                            };
                          })
                        );
                      } else {
                        setPayList(
                          payList.map((item) => {
                            return {
                              ...item,
                              checked: false,
                            };
                          })
                        );
                      }
                    }}
                  />
                </Th>
                <Th>
                  <TableText>강의명</TableText>
                </Th>
                <Th>
                  <TableText>아이디</TableText>
                </Th>
                <Th>
                  <TableText>이름</TableText>
                </Th>
                <Th>
                  <TableText>결제수단</TableText>
                </Th>
                <Th>
                  <TableText>결제금액</TableText>
                </Th>
                <Th>
                  <TableText>결제일자</TableText>
                </Th>
                <Th>
                  <TableText>상세보기</TableText>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {payList.map((item, index) => {
                return (
                  <Tr
                    key={index}
                    style={{ height: "59px", background: "#fff" }}
                  >
                    <Td style={{ paddingLeft: "20px" }}>
                      <Checkbox
                        checked={item.checked}
                        onChange={() => {
                          item.checked = !item.checked;
                          setPayList([...payList]);
                        }}
                      />
                    </Td>
                    <Td>
                      <TableText
                        style={{
                          width: "220px",
                        }}
                      >
                        {item.lectureTitle}
                      </TableText>
                    </Td>
                    <Td>
                      <TableText>{item.account}</TableText>
                    </Td>
                    <Td>
                      <TableText>{item.name}</TableText>
                    </Td>
                    <Td>
                      <TableText>{item.payMethod}</TableText>
                    </Td>
                    <Td>
                      <TableText>{item.realPay?.toLocaleString()}원</TableText>
                    </Td>
                    <Td>
                      <TableText>
                        {moment(item.createdAt).format("YYYY/MM/DD")}
                      </TableText>
                    </Td>
                    <Td>
                      <DetailBtn
                        onClick={() => {
                          navigate(route.payment_pay_detail + `/${item.id}`);
                        }}
                      />
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>
          <Pagination
            route={route.payment_pay}
            queryString={`keyword=${encodeURIComponent(searchParams.get("keyword") || "")}`}
            currentPage={page}
            totalPages={pagination.totalPages}
            rangeSize={pagination.rangeSize}
          />
        </TableLayout>
      </MainLayout>
    </>
  );
};

export default Pay;

const AnswerText = styled(PretendardText)`
  font-weight: 600;
  font-size: 14px;
  line-height: 22.75px;
  color: ${(props) => (props.isAnswer ? "#000" : "#004098")};
`;
